export default __webpack_public_path__ + "static/media/IBMAddDisabled.d218111c.svg";